import { Injectable, Inject } from '@angular/core';

import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import Prism from "prismjs";

/* Import plugins and languages from prism package */
import 'prismjs/plugins/line-numbers/prism-line-numbers';
import 'prismjs/plugins/toolbar/prism-toolbar';
import 'prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard';

import 'prismjs/components/prism-lua';
import 'prismjs/components/prism-xml-doc';

@Injectable()
export class CodeEditorService {

    constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

    /**
    * Change color of code block text
    */
    public highlightAll(): void {
        if (isPlatformBrowser(this.platformId)) {
            Prism.highlightAll();
        }
    }
}